module.exports = __webpack_public_path__ + "img/dialog_coupon_99.000df5da.png";